import { render } from "./Institutional.vue?vue&type=template&id=5d130f0c"
import script from "./Institutional.vue?vue&type=script&lang=js"
export * from "./Institutional.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__